const Data = [
  {
    id: 1,
    category: "education",
    icon: "icon-graduation",
    year: "2017 - 2019",
    title: "High School - Brazil",
    desc: "Colégio Santa Maria Minas, Belo Horizonte, MG",
  },
  {
    id: 2,
    category: "education",
    icon: "icon-graduation",
    year: "2019 - 2020",
    title: "Exchange Program - High School - Canada",
    desc: "Glebe Collegiate Institute, Ottawa, ON",
  },
  {
    id: 3,
    category: "education",
    icon: "icon-graduation",
    year: "2021 - 2025",
    title: "Computer Science Graduation",
    desc: "PUC Minas, Belo Horizonte, MG, Brazil",
  },
  {
    id: 4,
    category: "education",
    icon: "icon-graduation",
    year: "2025",
    title: "Informatic Engineering Exchange Program",
    desc: "Instituto Politecnico da Guarda, Guarda, Portugal",
    isSubcategory: true
  },
  {
    id: 5,
    category: "experience",
    icon: "icon-briefcase",
    year: "2022 - 2023",
    title: "Monitoring",
    desc: "Helping students in subjects such as Algorithms and Data Structures, Web Development and Intelligent Systems",
  },
  {
    id: 6,
    category: "experience",
    icon: "icon-briefcase",
    year: "2023 - 2024",
    title: "Andritz Internship",
    desc: "Development of new features and bug solutions for the company's factory system in C#, .NET, WPF e React",
  },
  {
    id: 7,
    category: "experience",
    icon: "icon-briefcase",
    year: "2024 - 2025",
    title: "DTI Internship",
    desc: "Development of new features and bug solutions for IGAM and Vale to control the water quality in AngularJS, Java, PostgreSQL",
  },
  {
    id: 8,
    category: "experience",
    icon: "icon-briefcase",
    year: "2025",
    title: "ULSG Summer Internship",
    desc: "Development of new features and bug solutions for the hospital's intranet system in AngularJS, Java, PostgreSQL",
    isLast: true
  },
];

export default Data;
